import styled from 'styled-components';

export const StepperWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
  margin-bottom: ${({ theme }) => theme.landingSpacing.xl};
  user-select: none;
  flex-wrap: wrap;
  row-gap: ${({ theme }) => theme.landingSpacing.sm};

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    margin-bottom: ${({ theme }) => theme.landingSpacing.lg};
  }
`;

export const Step = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
`;

export const Dot = styled.div`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
  border: 1.5px solid ${({ theme }) => theme.landing.cardBorder};
  color: ${({ theme }) => theme.landing.textSecondary};
  background: ${({ theme }) => theme.landing.background};
  transition: all 0.2s ease;

  ${({ $done, theme }) =>
    $done &&
    `
      background: ${theme.landing.buttonBg};
      border-color: ${theme.landing.buttonBg};
      color: #fff;
    `}

  ${({ $active, theme }) =>
    $active &&
    `
      border-color: ${theme.landing.buttonBg};
      color: ${theme.landing.buttonBg};
      background: rgba(37, 99, 235, 0.1);
    `}
`;

export const Label = styled.div`
  font-size: 13.5px;
  font-weight: 600;
  color: ${({ theme }) => theme.landing.textSecondary};
  opacity: 0.7;

  ${({ $done }) => $done && `opacity: 0.9;`}
  ${({ $active, theme }) =>
    $active &&
    `
      color: ${theme.landing.text};
      opacity: 1;
    `}

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    display: none;
  }
`;

export const StepLine = styled.div`
  width: 56px;
  height: 1.5px;
  background: ${({ theme }) => theme.landing.cardBorder};
  margin: 0 10px;
  transition: background 0.2s ease;

  ${({ $done, theme }) => $done && `background: ${theme.landing.buttonBg};`}

  @media (max-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    width: 28px;
    margin: 0 6px;
  }
`;
